module.exports = "/_next/static/images/attorney-gandhi-334bf8d4ea31dbc495ed1e7fb6378555.jpg";